<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getTimeStamp, setTimeStamp } from "./utils/auth";

export default {
  name: "App",
  created() {
    var timeStamp = getTimeStamp();
    if (!timeStamp) {
      setTimeStamp(new Date().getTime());
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  border: 0;
  hyphens: auto;
  box-sizing: border-box;
}

#app {
  overflow: hidden;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  /* width: 1920px;
  height: 1080px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue